export const staticFields:Map<string, string[]> = new Map();
staticFields.set('time', ['__in_date', '__out_date']);
staticFields.set('timeline', ['__timeline']);
staticFields.set('vendor', ['__vm_vendor_zone','__vm_power_details','__vm_name', '__vm_status', '__vm_furniture', '__vm_fresh_water', '__vm_grey_water', '__vm_internet']);
staticFields.set('cost', ['__cost']);
staticFields.set('supplier', ['__supplier']);
staticFields.set('ue', ['__ue_level', '__ue_floor']);
